export default "__VITE_ASSET__065e4575__"